import { useMutation } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';
import getCurrentUser from '../user/getCurrentUser';

const useUploadOrgLogo = () => {
  const getCurrentUserQuery = getCurrentUser();
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const response = await post<{ logoPath: string }>(
        '/v1.0/org/logo',
        formData,
      );
      return response.data;
    },
    onSuccess: () => {
      getCurrentUserQuery.refetch();
    },
  });
};

export default useUploadOrgLogo;
